"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountsByCollectionAddress = void 0;
const programIds_1 = require("../constants/programIds");
const candyMachine_1 = require("./candyMachine");
const schema_1 = require("./tokenMetadata/schema");
async function getAccountsByCollectionAddress(collection, connection) {
    let metadataAccounts = [];
    for (let numberOfCreators = 5; numberOfCreators > 0 && metadataAccounts.length == 0; numberOfCreators--) {
        metadataAccounts = await candyMachine_1.getProgramAccounts(connection, programIds_1.TOKEN_METADATA_PROGRAM_ID.toBase58(), {
            filters: [
                {
                    memcmp: {
                        offset: 1 + // key
                            32 + // update auth
                            32 + // mint
                            4 + // name string length
                            candyMachine_1.MAX_NAME_LENGTH + // name
                            4 + // uri string length
                            candyMachine_1.MAX_URI_LENGTH + // uri*
                            4 + // symbol string length
                            candyMachine_1.MAX_SYMBOL_LENGTH + // symbol
                            2 + // seller fee basis points
                            1 + // whether or not there is a creators vec
                            4 + // creators vec length
                            numberOfCreators * candyMachine_1.MAX_CREATOR_LEN +
                            1 + // primary sale happened
                            1 + // is mutable
                            2 + // edition nonce + option
                            1 + // token standard (not present)
                            1 + // whether or not there is a collection
                            1,
                        bytes: collection,
                    },
                },
            ],
        });
        if (metadataAccounts.length == 0) {
            console.log("Found no collection when assuming creators =", numberOfCreators, ". Trying with creators = ", numberOfCreators - 1, "next.");
        }
        else {
            console.log("Found mints for collection", collection);
        }
    }
    const decodedAccounts = [];
    for (let i = 0; i < metadataAccounts.length; i++) {
        const e = metadataAccounts[i];
        const decoded = await schema_1.decodeMetadata(e.account.data);
        const accountPubkey = e.pubkey;
        const store = [decoded, accountPubkey];
        decodedAccounts.push(store);
    }
    return decodedAccounts;
}
exports.getAccountsByCollectionAddress = getAccountsByCollectionAddress;
